import React, { useEffect } from 'react'
import styled from 'styled-components'

import AtriusLogoSVG from '../../../../src/images/atrius-logo-standard.svg'
import { Button } from '../../../../src/ui/buttons/Button.jsx'
import { withModalWindow } from '../../../../src/ui/modals/ModalWindowMol.jsx'
import { handleKeyboardSelect } from '../../../utils/keyboardUtils.js'

const StyledModalBox = styled.div`
  &.-desktop {
    width: 415px;
  }

  color: ${({ theme }) => theme.colors.primaryText};
  font-family: ${({ theme }) => theme.fonts.family};
  text-align: center;
`

const InfoBox = styled.div`
  line-height: 18px;
  font-family: ${({ theme }) => theme.fonts.family};
  ${({ theme }) => theme.fontSize('14px')};
`

const Attributions = styled.div`
  font-weight: 500;
  font-size: 150%;
  ${({ theme }) => theme.fontSize('14px')};
  line-height: 18px;
  margin-top: 24px;
`

const ThirdParty = styled.div`
  font-size: 80%;
  margin: 1em 0;
`

const MapState = styled.div`
`

const PolicyUrl = styled.a`
  line-height: 26px;
  ${({ theme }) => theme.fontSize('16px')};
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
`

const PropertyNameLabel = styled.span`
  font-weight: 500;
`

const VersionLabel = styled.div`
  ${({ theme }) => theme.fontSize('22px')};
  font-weight: 500;
  line-height: 24px;

  margin-top: 16px;
  margin-bottom: 24px;
`

const AtriusLogo = styled.div`
  background: url(${AtriusLogoSVG}) no-repeat top center;
  background-size: contain;
  height: 87px;
  margin: auto;
`

const CloseButton = styled(Button)`
  ${({ theme }) => theme.borderRadius(8)};
  background-color: ${({ theme }) => theme.colors.primaryButton};
  :hover {
    background-color: ${({ theme }) => theme.colors.primaryButtonHover};
  }
  color: ${({ theme }) => theme.colors.primaryButtonText};
  width: 100%;
  text-align: center;
  padding: 16px 14px;
  font-weight: 500;
  ${({ theme }) => theme.fontSize('16px')};
  line-height: 150%;

  margin-top: 22px;
`

const identity = x => x

export const AttributionModalView = withModalWindow(({
  engineName,
  onModalDismiss,
  properties,
  setModalDismissAction,
  versionNumber,
  privacyPolicyUrl,
  tosUrl,
  T
}) => {
  useEffect(() => setModalDismissAction(onModalDismiss), [])
  return <StyledModalBox data-cy='AttributionModalView'>
    <AtriusLogo/>
    <VersionLabel>{ engineName } v{versionNumber}</VersionLabel>
    <div><PolicyUrl data-cy='TermsOfService' href={tosUrl} target="_blank">{T('attributionModal:Terms Of Service')}</PolicyUrl></div>
    <div><PolicyUrl data-cy='PrivacyPolicy' href={privacyPolicyUrl} target="_blank">{T('attributionModal:Privacy Policy')}</PolicyUrl></div>
    <Attributions>Attributions</Attributions>
    <ThirdParty>
      <div>Copyright (c) 2020, MapLibre contributors</div>
      <div>Contains code from mapbox-gl-js v1.13 and earlier</div>
    </ThirdParty>
    <MapState>
      {properties.filter(identity).map(prepareInfo)}
    </MapState>
    <CloseButton
      onClick={onModalDismiss}
      tabIndex={'0'}
      onKeyDown={handleKeyboardSelect(() => onModalDismiss())}
      aria-label={T('ui:Close')}
      data-cy='AttributionOkButton'
    >Ok</CloseButton>
  </StyledModalBox>
}, '[data-cy=AttributionOkButton]')

const prepareInfo = property => {
  if (property.type === AttributionDataType.SIMPLE)
    return prepareSimpleInfo(property)
  else if (property.type === AttributionDataType.COMPLEX)
    return (<div key={property.label}>
      <div><PropertyNameLabel>{property.label}</PropertyNameLabel></div>
      {property.value.filter(identity).map(prepareSuperSimpleInfo)}
    </div>)
  else return null
}

let itemNum = 1
const prepareSuperSimpleInfo = property => <div key={property.label}>{ property.label } : { property.value }</div>
const prepareSimpleInfo = property =>
  <InfoBox key={'attribution-modal-' + (itemNum++)}>
    <PropertyNameLabel>{property.label}: </PropertyNameLabel>
    {property.value || 'unknown'}
  </InfoBox>

export const AttributionDataType = {
  SIMPLE: 1,
  COMPLEX: 2
}
